import React from "react";
import { HistoricalChangesContainer } from "../../container/panelReports";

const HistoricalChangesScreen: React.FC<{}> = () => {
  return <HistoricalChangesContainer/>;
}

export default HistoricalChangesScreen;